export default "__VITE_ASSET__1408e140__"